module.exports = __webpack_public_path__ + "static/media/logo.d53f9553.png";